// TODO apply correct mixpanel events
// openFrom
// tabName
// Requirement count

import { Component, Vue } from 'vue-property-decorator'
import { FREEMIUM_PRO_MODAL } from '~/plugins/feature-flags/flags'
import { FREEMIUM_PRO_MODAL_VIDEO } from '~/plugins/feature-flags/variants'

const referrers = [
  'applicant_count',
  'application_status',
  'credibility',
  'header_navigation',
  'recommended_view',
  'no_requirements_view',
  'initial',
  'application_status_view',
  'automatically_reapply',
  'payment',
  'similarity_view',
  'blurred_card',
  'no_application',
  'credibility_banner'
] as const

export type Referrer = typeof referrers[number];

@Component
export default class Freemium extends Vue {
  get BOOST_CHANCES() {
    return this.isUpdatedVariant
      ? ['Boost your chance with Pro']
      : ['Unlock Pro to boost your', 'chances']
  }

  CREDIBILITY_SCORE = ['Unlock Pro to view', 'credibility scores']
  CREDIBILITY_BANNER = ['Unlock Pro to view', 'credibility scores']
  APPLICATION_STATUS = ['Unlock Pro to track', 'application status']
  REAPPLY_AUTOMATICALLY = ['Unlock Pro to reapply', 'automatically']
  APPLICANTS_NUMBER = ['Unlock Pro to view number', 'of applicants']
  RECOMMENDED_SCHOLARSHIPS = ['Unlock Pro to see', 'recommended scholarships']
  PAYOUT_METHOD = ['Unlock Pro to see', 'payment method']
  SIMILARITY_METHOD = ['Unlock Pro to see', 'similar scholarships']
  BLURRED_CARD = ['Unlock Pro to access all your', 'matches']
  NO_APPLICATION = ['Unlock Pro to apply directly', 'without leaving']

  contentByReferrer = {
    [referrers[0]]: this.APPLICANTS_NUMBER,
    [referrers[1]]: this.APPLICATION_STATUS,
    [referrers[2]]: this.CREDIBILITY_SCORE,
    [referrers[3]]: this.BOOST_CHANCES,
    [referrers[4]]: this.RECOMMENDED_SCHOLARSHIPS,
    [referrers[5]]: this.REAPPLY_AUTOMATICALLY,
    [referrers[6]]: this.BOOST_CHANCES,
    [referrers[7]]: this.APPLICATION_STATUS,
    [referrers[8]]: this.REAPPLY_AUTOMATICALLY,
    [referrers[9]]: this.PAYOUT_METHOD,
    [referrers[10]]: this.SIMILARITY_METHOD,
    [referrers[11]]: this.BLURRED_CARD,
    [referrers[12]]: this.NO_APPLICATION,
    [referrers[13]]: this.CREDIBILITY_BANNER
  }

  // move to mixpanel plugin
  eventByReferrer = {
    [referrers[0]]: 'Applicants tooltip',
    [referrers[1]]: 'Status tooltip',
    [referrers[2]]: 'Credibility tooltip',
    [referrers[3]]: 'Unlock pro button navigation',
    [referrers[4]]: 'Recommended screen',
    [referrers[5]]: 'Recurring no requirement screen',
    [referrers[6]]: 'Welcome',
    [referrers[7]]: 'Application sent screen',
    [referrers[8]]: 'Automatically reapply tooltip',
    [referrers[9]]: 'Payment method tooltip',
    [referrers[10]]: 'Similarity sent screen',
    [referrers[11]]: 'Upgrade to unlock blurred button',
    [referrers[12]]: 'Unlock to apply directly button',
    [referrers[13]]: 'Freemium credibility banner'
  }

  getReferrerContent(referrer: Referrer) {
    if (this.contentByReferrer[referrer]) {
      return {
        title: this.contentByReferrer[referrer],
        mixpanelEvent: this.eventByReferrer[referrer] || ''
      }
    }
    return { title: [], mixpanelEvent: '' }
  }

  get isMob() {
    return this.$accessor.screen.resolution < 768
  }

  get maxWidth() {
    const oldVariant = this.isMob
      ? '375px'
      : '855px'
    const newVariant = this.$accessor.screen.isMobile
      ? `${this.$accessor.screen.resolution - 16}px`
      : '648px'
    return this.isUpdatedVariant
      ? newVariant
      : oldVariant
  }

  get isUpdatedVariant() {
    return this.$accessor.featureSet.isFreemiumMVP && this.$featureFlags?.getVariant?.(FREEMIUM_PRO_MODAL)?.name === FREEMIUM_PRO_MODAL_VIDEO
  }

  openModal({ referrer }: { referrer: Referrer }) {
    const componentName = this.isUpdatedVariant
      ? 'FreemiumModalWithVideo'
      : 'FreemiumModal'
    const { title, mixpanelEvent } = this.getReferrerContent(referrer)
    const classes = [
      'my-xxl',
      'md:my-0'
    ]

    if (this.isUpdatedVariant) {
      classes.push('rounded-lg')
    }

    this.$modal.show(Vue.component(componentName), {
      title,
      mixpanelEvent,
      isMob: this.isMob
    }, {
      width: this.maxWidth,
      scrollable: true,
      classes: classes.join(' ')
    })
  }
}
